<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
        <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
        </v-overlay>

      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1" :ripple="true"> مشاهده QR</v-tab>

            <v-tab :ripple="true"> پیش نمایش</v-tab>
            <v-tab :ripple="true" :disabled="e6 <= 1">تعرفه‌ها</v-tab>

          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <qr-maker :loading="loading" />
              <div class="rowinfo">
                <v-btn
                  class="btn-download contnetinfo"
                  @click="showDialog = true"
                >
                  <v-icon>mdi-progress-download</v-icon>
                  {{ $t("download_qr") }}                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-data-downloadQr`"
                  :help-data="helpData"
                  :service-name="serviceName"
                  class="buttoninfo"
                  label="دانلود کیوآر"
                />
              </div>
            </v-tab-item>

            <v-tab-item>
              <component
                :is="theme"
                v-model="cardTexts"
                :order.sync="cardTexts.order"
                :components="specialInfo"
                :qr-svg-data-url="qrSvgDataUrl"

              />
            </v-tab-item>
          <v-tab-item v-if="!!info?.id && e6>1">
              <Tariffs :id_qr="info.id" :qrtype="'goldlabel'" />
          </v-tab-item>

          </v-tabs-items>
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>وارد کردن اطلاعات طلا</p>
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="نام طلای شما"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :help-data="helpData"
                    :service-name="serviceName"
                    class="buttoninfo"
                    label="نام طلا"
                  />
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <qr-address-field
                    id="qr-address"
                    ref="address-field"
                    v-model="dtUrl"
                    :disabled="e6 > 1"
                    :error-messages="errors['identifier']"
                    append-icon="mdi-web"
                    class="mt-0 pt-0 contentinfo"
                    dense
                    outlined
                    persistent-hint
                    @updateDest="domainId = $event"
                    :key="$t('qrAddressUpdate.hints.allowedChars')"
                    :hint="$t('qrAddressUpdate.hints.allowedChars')"

                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-dtUrl`"
                    :help-data="helpData"
                    :service-name="serviceName"
                    class="buttoninfo"
                    label="آدرس کیوآر"
                  />
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content step="1">
              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr"
                />
              </div>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2"
              >اطلاعات</v-stepper-step
            >
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <div class="d-flex row mx-0 my-2">
                <v-btn
                  :disabled="e6 > 2"
                  class="my-4"
                  color="third"
                  outlined
                  @click="clearDefaults"
                >
                  <v-icon class="me-2">mdi-delete</v-icon>
                  حذف اطلاعات پیشفرض
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-clearDefaults`"
                  :help-data="helpData"
                  :service-name="serviceName"
                  label="حذف اطلاعات پیش‌فرض"
                />
              </div>
               <div class="mb-4 mx-4">
                    <!-- سوییچ و آیکون راهنما -->
                    <div class="d-flex align-center">
                      <v-switch
                        v-model="AutoSave"
                        color="primary"
                        class="mt-0 pt-0 shrink"
                        hide-details
                        label="ذخیره خودکار"
                      ></v-switch>

                      <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="mr-1"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop
                          >
                            <v-icon small color="grey darken-1">
                              mdi-help-circle-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>
                          تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                        </span>
                      </v-tooltip>
                    </div>

                    <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                    <div
                      v-if="$vuetify.breakpoint.xsOnly"
                      class="text-caption grey--text text--darken-1 mt-1 pr-1"
                      style="line-height: 1.4"
                    >
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                    </div>
                  </div>

              <list-expansion
                v-model="cardTexts"
                :component-name="componentName"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                flat
                @save-required="AutoSave && qrUpdate(false)"
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="qrUpdate(true)"
                />
              </div>
            </v-stepper-content>
          </v-stepper>

          <div class="d-none">
            <qr-code-make
              v-if="e6 > 1"
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="cons"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-show-download-d`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo"
              label="دانلود کیوآر"
            />
          </template>
          <v-card class="pa-5">
            <download-file-with-api
              v-if="showDialog"
            :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
              :visit-name="cardTexts.visitName"
            :qr_id="info.qrId"

            />
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { getLanguageCookie } from "../../../core/plugins/TitleRibbon/utils/languageCookie";
import HelpInfo from "../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrGenerator from "../qrland/components/qrGenerator";
import QrMaker from "../qrland/components/qrMaker";
import { Bus } from "@/main";
import QrCustomize from "../qrland/components/qrCustomize.vue";
import ListExpansion from "../../content/fragments/listExpansion";
import NextBtn from "../../content/fragments/nextBtn";
import PrevBtn from "../../content/fragments/prevBtn";
import QrAddressField from "../../content/fragments/qrAddressField";
import NewProCard from "@/view/components/Product/newProCard";
import ProductTheme2 from "@/view/pages/product/productTheme2";
import ThemeSelector2 from "@/view/pages/product/themeSelector";
import NewDesign from "@/view/pages/product/newDesign";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import ImageToTextInfAi from "@/view/components/adapters/AIGeneration/imageToTextInfAi.vue";
import armsChooser from "@/view/components/Product/armsChooser.vue";
import newFactoryLabel from "./components/newFactoryLabel";
import { mapActions } from "vuex";
import DownloadFileWithApi from "../qrland/downloadFileWithApi.vue";
import Tariffs from "../../components/Tariffs/Tariffs.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "createGoldLabel",

  components: {
    ImageToTextInfAi,
    HelpInfo,
    HelpInfoWrapper,
    QrCodeMake,
    NewDesign,
    ThemeSelector2,
    ProductTheme2,
    NewProCard,
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    DownloadFileWithApi,
    QrCustomize,
    QrMaker,
    QrGenerator,
    armsChooser,
    newFactoryLabel,
    Tariffs,
    AtomSpinner
  },

  data() {
    return {
      isAutoSaving: false, 
      AutoSave:false,
      helpData: [],
      serviceName: "Qrland",
      componentName: "product-card-shop",
      theme: "newFactoryLabel",
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      e6: 1,
      errors: {},
      createdDomain: null,
      createdId: null,
      picFrames: [
        { name: "newProCard", src: "/media/frame/themes/2.svg" },
        { name: "productTheme2", src: "/media/frame/themes/t2.webp" },
        { name: "newDesign", src: "/media/bg/product.webp" },
      ],
      customTheme: [
        { name: "newProCard", value: "" },
        { name: "productTheme2", value: "" },
        { name: "newDesign", value: "" },
      ],
      finish: true,
      loading: false,
      showDialog: false,
      specialInfo: [
        {
          name: "factoryGoldLabel",
          value: "",
          title: "اطلاعات طلا",
          subtitle: "",
          icon: "account-outline",
          model: "gold",
        },

        {
          name: "myassets",
          value: "",
          title: "مدیریت دارایی",
          subtitle: "",
          icon: "cash-multiple",
          model: "myassets",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
          secondName: "شبکه های اجتماعی",
        },
        {
          name: "VideoGallery",
          value: "",
          title: "افزودن ویدئو",
          subtitle: "",
          icon: "video-image",
          settings: {
            notColor: true,
          },
          // model: 'video_single'
        },
        {
          name: "imageUploader2",
          value: "",
          title: "افزودن تصویر",
          subtitle: "",
          icon: "cloud-upload-outline",
          model: "photo",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
          secondName: "",
        },
      ],
      headColor: "linear-gradient(to right , #D81A1AFF, #2115A7FF)",
      dtUrl: null,
      domainId: null,
      cardTexts: {
        advanceSettings: {
          viewConfigs: {
            autoCsvDownload: false,
            showCClubOnload: false,
            forcedSubmission: "optional",
          },
        },
        customerClub: {
          configs: {
            isActive: true,
            smsType: "pattern",
            patternId: 487,
          },
        },

        FeedBack: {
          title: "بازخورد شما",
          description:
            "لطفا با پاسخ گویی به سوالات زیر مارا در خدمات بهتر راهنمایی فرمایید",
          sectionColor: {
            backGround: "linear-gradient(to right , #FFFFFFFF, #FFFFFFFF)",
            text: "#fff",
          },
          type: "text",
          items: [
            {
              question: "چقدر از خدمات کیوآرلند راضی بوده اید؟",
              answer: "",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question:
                "خدمات کیوآرلند چه میزان از نیازهای شما را پوشش داده است؟",
              answer: "",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question:
                "میزان هزینه پرداختی بابت سرویس دریافتی چقدر معقول بوده است؟",
              answer: "",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question: "برای  بهبود خدمات نظر خود را با ما درمیان بگذارید.",
              answer: "",
              value: null,
              description: true,
              forceDesc: false,
            },
          ],
        },
        pallete: {
          headColor: "linear-gradient(to top left , #FCCF5B, #BE9639)",
          bodyColor: "linear-gradient(to top left , #006064FF, #03A9F4FF)",
          textColor: "#000",
          borderColor: "#393939",
        },
        order: [
          { name: "price" },
          { name: "type" },
          { name: "weight" },
          { name: "cutie" },
          { name: "create_name" },
          { name: "create_at" },
          { name: "wages" },
          { name: "fee" },
          { name: "profit" },
          { name: "tax" },
          { name: "more" },
          { name: "discriptions" },
          { name: "discount" },
          { name: "img" },
          { name: "video" },
        ],
        gold: {
          price: { text: 50000000, line: false },
          name: "طلا سرا",
          goldName: "انگشتر زرین",
          type: { text: "نو", value: "new", line: false },
          weight: { text: 1, line: false },
          cutie: { text: 18, line: false },
          create_name: { text: null, line: false },
          create_at: { text: null, line: false },
          more: [],
          wages: {
            value: 0,
            type: "price",
            line: false,
          },
          fee: {
            value: 0,
            type: "price",
            line: false,
          },
          tax: { text: 9, line: false },
          discriptions: { text: "", line: false },
          discount: { text: null, line: false },
          model: {
            value: "/v2/gold/db",
            text: "رهاورد",
          },
          img: { text: false, line: false },
          video: { text: true, line: false },
        },

        myassets: {},
        visitName: "لیبل طلا",
        isGradient: false,
        organizationName: "شیوا امواج",
        subOrgan: "به بهترین ها فکر کنید...",
        userName: "",
        workField: "1373",
        phoneNumber: [
          { number: "09134034351", text: "" },
          { number: "09130363030", text: "" },
        ],
        extraFields: [{ icon: "", name: "", value: "" }],
        companyNumber: "03135723690",
        companyNumberName: "",
        email: "info@shivaamvaj.com",
        fax: "03135723400",
        location: "ایران ،زنجان،ابهر،شهرک صنعتی شریف ، جنب پست برق 63/20",
        city: "",
        photo: {
          gallery: [
            {
              name: "",
              images: [],
            },
          ],
          background:
            "https://zcoinn.com/wp-content/uploads/2024/12/emerates-1-kg-with-bg.webp",
          headBackground:
            "https://media.fardayeeghtesad.com/d/2022/12/19/4/11718.jpg?ts=1671456693000",
          profile:
            "https://cdn.terminalads.com/upload/golden-glitter-circle-frame-elegant-design-element_632498-25631.webp",
          transition: "scale",
          hasWelcome: false,
          hasGif: false,
          hasGame: false,
          headTransparent:false,
          backgroundTransparent: false,
          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
        },
        codePostal: "1541946815",
        province: "",
        country: "",
        website: "www.shivaamvaj.com",
        socialMedia: {},
        aboutUs: "",
        VideoGallery: {
          title: "گالری ویدئو",
          description: "از ویدئوهای مجموع ما دیدن فرمایید.",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        video_gallery: [
          {
            name: "گالری",
            images: [
              {
                name: "خوش آمدگویی",
                title: "",
                file_link:
                  "https://persian7.asset.aparat.com/aparat-video/1d2d2d8b5fea10b3cbda4fb6e2c45c7653042587-1080p.apt?wmsAuthSign=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6ImE4M2YzYThhNjZkNTlmZGZmNDQ5N2M3ZmM4YjM3YWI1IiwiZXhwIjoxNzQ2ODg3ODg1LCJpc3MiOiJTYWJhIElkZWEgR1NJRyJ9.uo0KLzsAr99yAtMt9iR-E1KGaa2iOgjMBstS8De4MKw",
                description: "",
                link: "",
                id: 15,
              },
            ],
          },
        ],
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: "",
        arm: [],
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      },
      qrShow: 1,
      destinationUrl: "",
      qrSvgDataUrl: "",
      info: null,
    };
  },

  provide: {
    provideSingleGallery: true,
  },

  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;

    this.cardTexts.gold.model.value = this.defaultGoldModelValue;
    this.cardTexts.socialMedia = {
      address: [
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: "اینستاگرام",
          text: "نام کاربری خود را وارد نمایید",
          pattern: "https://instagram.com/",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: "واتساپ",
          text: "+989123456789",
          pattern: "wa.me/",
          prefix: "mdi-phone",
          url: "+982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };

    Bus.$on("colorPalette", (value) => {
      this.cardTexts.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });

    Bus.$on("uploader", (value) => {
      console.log(value);

      this.cardTexts.photo = value;
    });

    Bus.$on("gradientType", (value) => {
      this.cardTexts.isGradient = value;
    });

    Bus.$on("model", (val) => {
      this.cardTexts.gold.model = {
        ...this.cardTexts.gold.model,
        source: val.value,
        name: val.title,
      };
    });
  },

  computed: {
    defaultGoldModelValue() {
      return this.$qrApi + "/v2/gold/db";
    },
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },

    "cardTexts.photo.gallery": {
      deep: true,
      immediate: true,
      handler(val) {
        this.$root.$emit("rerenderSwiper");

        if (val[0].images?.length > 0) {
          this.cardTexts.gold.img.text = true;
        } else {
          this.cardTexts.gold.img.text = false;
        }
      },
    },
    "cardTexts.video_gallery": {
      deep: true,
      immediate: true,
      handler(val) {
        const hasVideo = val?.some((item) => item.images.length > 0);
        if (this.cardTexts.gold) {
          this.cardTexts.gold.video.text = hasVideo;
        }
      },
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID", "setQrType"]),
    ...mapActions("local", [
      "updateQrId",
      "updateQridentifier",
      "updateQrInfo",
      "updateQrDomain",
    ]),

    markQr() {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error("آدرس وارد شده صحیح نمی‌باشد!");
        return;
      }

      this.loading = true;
      let obj = {
        type: "goldlabel",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: this.theme,
          data: this.cardTexts,
        }),
        qr: JSON.stringify(this.qrDesign),
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.loading = false;
          this.info = data.data;
          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId,
          ).name;
          this.createdId = data.data.identifier;
          this.updateQrDomain(this.createDomain);
          this.createdId = data.data.identifier;
          this.updateQridentifier(data.data.identifier);
          this.setCreatedQrID(data.data.id);
          this.updateQrId(data.data.id);
          this.setQrType("goldlabel");
          this.$toast.success("کیوار لیبل طلا شما با موفقیت ساخته شد.");
          if (this.e6 === 1) {
            this.e6 = 2;
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate(false);
              }, 2000);
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.status === 422)
            this.$modal.error("خطا", response.data.message);
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "goldlabel");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("qr_id", this.info.qrId);

      data.append("_method", "PUT");
      data.append(
        "data",
        JSON.stringify({
          theme: this.theme,
          data: this.cardTexts,
        }),
      );
      data.append("qr", JSON.stringify(this.qrDesign));

      this.$api
        .post("/v1/testQr/update", data)
        .then((res) => {
          if(final || !this.AutoSave)
          this.$toast.success("کیوآر لیبل طلای شما باموفقیت ویرایش شد.");
          final && this.goto("qr/list");
        })
        .catch((err) => {
        })
        .finally(() => {
            this.loading = false;
          this.isAutoSaving = false;
        });
    },
    clearDefaults() {
      this.$root.$emit("clearDefaultData");
      this.cardTexts.video_gallery = [
        {
          name: "",
          images: [],
        },
      ];
      this.cardTexts.visitName = "";
      this.cardTexts.isGradient = false;
      this.cardTexts.organizationName = "";
      this.cardTexts.subOrgan = "";
      this.cardTexts.userName = "";
      this.cardTexts.workField = "";
      this.cardTexts.phoneNumber = [{ number: "" }];
      this.cardTexts.extraFields = [
        {
          icon: "",
          name: "",
          value: "",
        },
      ];
      this.cardTexts.gold = {
        price: { text: null, line: false },
        name: "",
        goldName: "",
        type: { text: null, value: null, line: false },
        weight: { text: null, line: false },
        cutie: { text: null, line: false },
        create_name: { text: "", line: false },
        create_at: { text: "", line: false },
        wages: {
          value: 0,
          type: "price",
          line: false,
        },
        fee: {
          value: 0,
          type: "price",
          line: false,
        },
        tax: { text: null, line: false },
        more: [],
        discriptions: { text: "", line: false },
        discount: { text: null, line: false },
        model: {
          value: this$qrApi + "/v2/gold/db",
          text: "رهاورد",
        },
        myassets: {
          gold: [],
          crypto: [],
          currency: [],
          coin: [],
          shares: [],
          gold_funds: [],
        },
        img: { text: false, line: false },
        video: { text: true, line: false },
      };
      this.cardTexts.Features = {
        show: "accordion",
        details: [
          {
            name: "",
            showIt: false,
            value: [],
          },
        ],
      };
      this.cardTexts.companyNumber = "";
      this.cardTexts.email = "";
      this.cardTexts.fax = "";
      this.cardTexts.location = "";
      this.cardTexts.city = "";
      this.cardTexts.singleProduct = {
        name: "",
        description: "",
        price: 0,
        discount: "0",
        payLink: "",
        btnSetting: {
          title: "",
          icon: undefined,
          background: "linear-gradient(to top left , #D81A1AFF, #2115A7FF)",
          color: "white",
        },
        extra: [
          {
            label: "",
            value: "",
            icon: "",
            name: "",
            link: "",
          },
        ],
        image: "",
        color: undefined,
        arm: [],
      };
      this.cardTexts.photo = {
        gallery: [
          {
            name: "",
            images: [],
          },
        ],
        background: "",
        headBackground: "",
        profile: "",
        transition: "scale",
        hasWelcome: false,
        hasGif: false,
        hasGame: false,

        previewerQr: {
          previewer: {
            gif: "",
            game: {},
            transition: "scale",
          },
        },
      };
      this.cardTexts.codePostal = "";
      this.cardTexts.province = "";
      this.cardTexts.country = "";
      this.cardTexts.website = "";
      this.cardTexts.socialMedia = {};
      this.cardTexts.aboutUs = "";
      this.cardTexts.video_single = {
        name: "",
        videos: [],
      };

      this.cardTexts.center = [51.420296, 35.732379];
      this.cardTexts.coordinates = null;
      this.cardTexts.address = "";
      this.cardTexts.apiKey =
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg";
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
